import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { authService, bilibiliService, permissionService } from '../services';

function Home() {
  const isAuthenticated = authService.isAuthenticated();
  const user = authService.getCurrentUser();
  const [biliInfo, setBiliInfo] = useState(null);
  const [userPermissions, setUserPermissions] = useState(null);

  useEffect(() => {
    bilibiliService.getInfo()
      .then(data => setBiliInfo(data))
      .catch(console.error);
  }, []);

  useEffect(() => {
    const loadPermissions = async () => {
      if (isAuthenticated && user?.role !== 'admin') {
        try {
          const perms = await permissionService.getMyPermissions();
          setUserPermissions(perms);
        } catch (error) {
          console.error('Failed to load permissions:', error);
        }
      }
    };
    loadPermissions();
  }, [isAuthenticated, user?.role]);

  const hasPermission = (permKey) => {
    if (!isAuthenticated) return false;
    if (user?.role === 'admin') return true;
    return userPermissions?.permissions?.includes(permKey);
  };

  const hasBotAccess = () => {
    return hasPermission('bot.admin') || hasPermission('bot.room.view');
  };

  const hasMarshmallowAccess = () => {
    return hasPermission('marshmallow.manage');
  };

  return (
    <div className="container">
      <div style={{ textAlign: 'center', marginTop: '4rem' }}>
        {biliInfo && (
          <a 
            href={`https://space.bilibili.com/${biliInfo.mid}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'none', color: 'inherit', display: 'inline-flex' }}
          >
            <div className="bili-profile-card">
              <div className="bili-avatar-wrapper">
                <img 
                  src={biliInfo.face} 
                  alt="Avatar" 
                  className="bili-avatar"
                  referrerPolicy="no-referrer"
                />
              </div>
              <div className="bili-info-content">
                <div className="bili-username-row">
                  <span className="bili-username">{biliInfo.name}</span>
                  <span className="bili-badge">UP主</span>
                </div>
                <div className="bili-stats-row">
                  <div className="bili-stat-item">
                    <span className="bili-stat-value">{biliInfo.archive_count}</span>
                    <span className="bili-stat-label">投稿</span>
                  </div>
                  <div className="bili-stat-item">
                    <span className="bili-stat-value">{biliInfo.fans}</span>
                    <span className="bili-stat-label">粉丝</span>
                  </div>
                  <div className="bili-stat-item">
                    <span className="bili-stat-value">{biliInfo.likes}</span>
                    <span className="bili-stat-label">获赞</span>
                  </div>
                </div>
              </div>
            </div>
          </a>
        )}
        <h1 className="page-title">欢迎来到小猪anna的秘密基地 🎵</h1>
        <p className="page-subtitle">
          {biliInfo?.sign || "只有音乐最安全！"}
        </p>
        
        <div style={{ 
          display: 'flex', 
          gap: '2rem', 
          justifyContent: 'center', 
          marginTop: '3rem',
          flexWrap: 'wrap' 
        }}>
          <Link to="/playlists" style={{ textDecoration: 'none' }}>
            <div className="card" style={{ width: '300px', textAlign: 'center' }}>
              <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🎵</div>
              <h2 className="card-title">网页歌单</h2>
              <p className="card-description">
                快来看看猪会什么歌吧！
              </p>
            </div>
          </Link>

          <Link to="/marshmallows" style={{ textDecoration: 'none' }}>
            <div className="card" style={{ width: '300px', textAlign: 'center' }}>
              <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🍬</div>
              <h2 className="card-title">棉花糖</h2>
              <p className="card-description">
                给猪发送匿名消息~
              </p>
            </div>
          </Link>
          
          {isAuthenticated && (
            <Link to="/prizes" style={{ textDecoration: 'none' }}>
              <div className="card" style={{ width: '300px', textAlign: 'center' }}>
                <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🎁</div>
                <h2 className="card-title">积分兑换</h2>
                <p className="card-description">
                  舰长礼物等都在这里兑换哦！
                </p>
              </div>
            </Link>
          )}
          
          {isAuthenticated && (hasBotAccess() || user?.role === 'admin') && (
            <Link to="/admin/bot" style={{ textDecoration: 'none' }}>
                <div className="card" style={{ width: '300px', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', border: '2px solid var(--primary-purple)' }}>                    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🤖</div>
                    <h3 className="card-title">Bot 配置</h3>
                    <p className="card-description" style={{ fontSize: '0.9rem' }}>
                      管理直播间 Bot 的设置和功能
                    </p>
                  </div>
            </Link>
          )}

          {isAuthenticated && user?.role === 'admin' && (
            <Link to="/admin/permissions" style={{ textDecoration: 'none' }}>
                <div className="card" style={{ width: '300px', textAlign: 'center', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', border: '2px solid var(--primary-purple)' }}>                    <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔐</div>
                    <h3 className="card-title">权限管理</h3>
                    <p className="card-description" style={{ fontSize: '0.9rem' }}>
                      管理用户角色和功能权限
                    </p>
                  </div>
            </Link>
          )}
        </div>

        <div style={{ 
          marginTop: '6rem', 
          padding: '2rem 0',
          color: '#e4daeaff',
          fontSize: '0.8rem',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.5rem'
        }}>
          <a 
            href="https://beian.miit.gov.cn/" 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.3s' }}
            onMouseOver={(e) => e.target.style.color = '#ddd4e2ff'}
            onMouseOut={(e) => e.target.style.color = '#e4daeaff'}
          >
            {process.env.REACT_APP_BEIAN_ICP}
          </a>
          <a 
            href="http://www.beian.gov.cn/portal/registerSystemInfo" 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ color: 'inherit', textDecoration: 'none', transition: 'color 0.3s' }}
            onMouseOver={(e) => e.target.style.color = '#ddd4e2ff'}
            onMouseOut={(e) => e.target.style.color = '#e4daeaff'}
          >
            {process.env.REACT_APP_BEIAN_GONGWANG}
          </a>
        </div>
      </div>
    </div>
  );
}

export default Home;
